import { render, staticRenderFns } from "./SingleAutobuyerBox.vue?vue&type=template&id=ba5d0ea2&scoped=true&"
import script from "./SingleAutobuyerBox.vue?vue&type=script&lang=js&"
export * from "./SingleAutobuyerBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba5d0ea2",
  null
  
)

export default component.exports